<template>
  <div class="app-esim-push-with-token" :class="{ error: showErrorPage } ">
    <dyn-slot :slot-data="{errorMsg: this.errorMessage}" v-if="showErrorPage" :useVHTML="true"><slot name="ceError"></slot></dyn-slot>
    <div v-else-if="hasValidToken && !eSimInfoLoaded" class="verification-box card card--form">
      <div class="verification-box--head">
        <slot name="txtValidationHeadline">Lorem, ipsum dolor.</slot>
        <div class="info">
          <slot name="txtValidationHeadlineInfo">Lorem, ipsum dolor.</slot>
        </div>
      </div>
      <b-form @submit.prevent="loadAccessTokenQuery" :novalidate="true">
        <BirthdateInput
          ref="birthDateInput"
          :invalid.sync ="birthdateInvalid"
          :date.sync = "birthdate"
        >
          <template v-for="slot in possibleChildSlotsFor('Birthdate')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </BirthdateInput>
        <div class="row app-stepper">
          <button class="filled" :id="'submit-'+_uid" type="submit" :disabled="loading"><slot name="btnValidate">Lorem</slot></button>
        </div>
      </b-form>
    </div>
    <PushCart v-else-if="eSimInfoLoaded && !eSimUnavailable"
              :e-sim-q-r-information="eSimQRInformation"
              :e-sim-q-r-information-loaded="eSimInfoLoaded"
              :e-sim-status="eSimStatus"
              :e-sim-status-loaded="eSimInfoLoaded"
              :show-progress-error="showProgressError"
              @performESimPush="performESimPush"
              @performESimDeassign="performESimPushDelete"
              :with-token="true"
              ref="pushcart"
    >
      <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PushCart>
    <div v-else-if="eSimInfoLoaded && eSimUnavailable" class="card-wrapper">
      <div class="card">
        <h3><slot name="txtESimUnavailableHeadline"></slot></h3>
        <div class="card card--info">
          <slot name="txtESimUnavailable"></slot>
        </div>
      </div>
    </div>
    <div class="selfservice service" v-if="eSimInfoLoaded">
      <div class="selfservice-content-area">
        <div class="card-wrapper">
          <div class="card">
            <slot name="htmlESimFaq"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import useFeature from '@/mixins/useFeature'

import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import { splitError } from '@/helper/splitError'
import BirthdateInput from '@/components/forms/LabeledBirthdateInput.vue'
import { mapActions, mapGetters } from 'vuex'
import beErrors from '@/mixins/beErrors'
import PushCart from '@/components/process/generic/ESimPush/PushCart.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'ESimPushWithToken',
  mixins: [
    validationFlow,
    validationMixin,
    useFeature('esimPush'),

    beErrors,
    transaction('eSimPush')
  ],
  components: {
    PushCart,
    BirthdateInput
  },
  data: function () {
    return {
      loading: true,
      token: null,
      showErrorPage: false,
      validateToken: false,
      hasValidToken: false,
      errorMessage: null,
      eSimValidateToken: null,
      eSimInfoLoaded: false,
      activeAccordion: null,
      birthdateInvalid: true,
      birthdate: null,
      showProgressError: false,
      manualConfirmationIcon: '/files/flash/images/svg-icons/icon-password-open.svg',
      qrcodeConfirmationIcon: '/files/flash/images/svg-icons/icon-password-open.svg'
    }
  },
  mounted () {
    this.startLoader()
  },
  methods: {
    ...mapActions('esimPush', [
      'loadEsimPushInfos',
      'loadEsimPushStatus',
      'pushESim',
      'deassignESim'
    ]),
    performESimPush (eID) {
      this.showProgressError = false
      this.startLoader()

      this.pushESim({ eid: eID })
        .then(async () => {
          this.setErrorMessage()
          document.getElementById('header-wrapper').scrollIntoView({ behavior: 'smooth' })

          if (!this.errorMessage) {
            this.refetchEsimStatus()
            const data = {
              micro_conversion_category: 'confirm push esim',
              micro_conversion_value: 'esim activation landingpage'
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('micro conversion', data)
            }
          } else {
            this.errorToast(this.errorMessage)
            const data = {
              type: 'technical',
              message: this.errorMessage.substring(0, 50),
              code: String(this.beErrorGetLastErrorCode())
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        })
        .finally(() => {
          this.stopLoader()
        })
    },
    performESimPushDelete () {
      this.showProgressError = false
      this.startLoader()

      this.deassignESim()
        .then(async () => {
          this.setErrorMessage()
          document.getElementById('header-wrapper').scrollIntoView({ behavior: 'smooth' })

          if (!this.errorMessage) {
            this.refetchEsimStatus()
            const data = {
              micro_conversion_category: 'confirm remove esim',
              micro_conversion_value: 'esim activation landingpage'
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('micro conversion', data)
            }
          } else {
            this.errorToast(this.errorMessage)
            const data = {
              type: 'technical',
              message: this.errorMessage.substring(0, 50),
              code: String(this.beErrorGetLastErrorCode())
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        })
        .finally(() => {
          this.stopLoader()
        })
    },
    loadAccessTokenQuery (event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.$refs.birthDateInput) {
        this.$refs.birthDateInput.vflowForceFeedback()
      }
      if (!this.birthdateInvalid) {
        this.startLoader()
        this.loading = true
        this.errorMessage = null

        this.loadEsimPushInfos({ token: this.token, birthdate: this.birthdate }).then(() => {
          this.setErrorMessage()
          if (!this.errorMessage) {
            this.eSimInfoLoaded = true
            if (this.eSimDownloadInProgress) {
              this.refetchEsimStatus()
            }
          } else {
            this.errorToast(this.errorMessage)
            const data = {
              type: 'technical',
              message: this.errorMessage.substring(0, 50),
              code: String(this.beErrorGetLastErrorCode())
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.checkAndDisableLoader()
        }).finally(() => {
          this.checkAndDisableLoader()
        })
      } else {
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    refetchEsimStatus () {
      // Refetch Status to update view
      this.loadEsimPushStatus().then(() => {
        if (this.possibleActions.includes('PUSH_DEASSIGN')) {
          this.$refs.pushcart.openDeleteModal()
          this.pushCollapseVisible = true
          setTimeout(() => { document.getElementById('accordion-push').scrollIntoView({ behavior: 'smooth' }) }, 100)
        }
      })
    },
    setErrorMessage () {
      const errorMessage = this.beErrorGetLastMessage()
      const errorcategory = this.beErrorGetLastCategory()
      if (errorMessage && errorcategory === 'graphql') {
        // technical error message, do not use for customer
        this.errorMessage = this.fallbackErrorMessage
      }
      this.errorMessage = errorMessage
    },
    checkAndDisableLoader () {
      this.loading = false
      this.stopLoader()
    }
  },
  computed: {
    ...mapGetters('esimPush', {
      accessToken: 'getAccessToken',
      eSimStatus: 'getStatus',
      eSimQRInformation: 'getQRInfo'
    }),
    eSimDownloadInProgress: function () {
      return ['DOWNLOAD_IN_PROGRESS', 'IN_PROGRESS'].includes(this.eSimStatus?.eSimStatus)
    },
    eSimInstalled: function () {
      return this.eSimStatus?.eSimStatus === 'INSTALLED'
    },
    possibleActions: function () {
      return this.eSimStatus?.possibleActions && this.eSimStatus?.possibleActions.length > 0 ? this.eSimStatus.possibleActions : []
    },
    fallbackErrorMessage: function () {
      return this.getSlotText('txtDefaultError', 'Leider ist gerade ein Fehler aufgetreten. Bitte probier\'s gleich noch einmal oder melde dich telefonisch.')
    },
    eSimUnavailable: function () {
      return this.eSimStatus?.eSimStatus === 'UNAVAILABLE' || this.eSimStatus?.eSimStatus === 'UNAVAILABLE '
    }
  },
  apollo: {
    esimValidateToken: function () {
      this.$store.commit('clearMessages', {}, { root: true })
      const urlParams = new URLSearchParams(window.location.search)

      this.validateToken = true
      this.token = urlParams.get('token') || ''
      this.startLoader()

      return wrapQuery(gql`query eSimValidateToken($validateTokenInput: ESimValidateTokenInput!) {
        eSimValidateToken(eSimValidateTokenInput: $validateTokenInput) {
            success
          }
        }`, this, 'eSimValidateToken', {
        validateTokenInput: {
          brand: 'simon',
          token: this.token
        }
      }, () => {
        if (!this.$apollo.queries.esimValidateToken.loading) {
          this.hasValidToken = true
          this.stopLoader()
          this.checkAndDisableLoader()
        }
      },
      {
        skip: function () {
          return !this.validateToken
        }
      },
      (error) => {
        let message = ''
        splitError(error).forEach(e => {
          message = e.message
        })
        const data = {
          type: 'technical',
          message: message
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
        splitError(error).forEach(e => {
          this.$store.commit('addError', e)
        })
        this.setErrorMessage()
        this.showErrorPage = true
        this.stopLoader()
        this.checkAndDisableLoader()
      })
    }
  }
}
</script>
